
import useScrollAnimation from '../../../hooks/useScrollAnimation';

const ServiciosAdicionales = () => {
  const { ref: sectionRef, isVisible } = useScrollAnimation({ threshold: 0.1 });

  const servicios = [
    {
      icon: 'ri-car-washing-fill',
      title: 'Coches Accidentados',
      description: 'Compramos vehículos con cualquier tipo de daño por accidente en Gavá. Desde pequeños golpes hasta siniestros totales. Valoración inmediata y pago al instante.',
      features: ['Cualquier tipo de daño', 'Valoración en 2 horas', 'Pago inmediato'],
    },
    {
      icon: 'ri-time-fill',
      title: 'Coches Antiguos',
      description: 'Compramos coches antiguos y vehículos fuera de uso en Gavá. No importa cuántos años tenga tu coche, te ofrecemos el mejor precio del mercado.',
      features: ['Cualquier antigüedad', 'Sin ITV necesaria', 'Recogida gratis'],
    },
    {
      icon: 'ri-exchange-fill',
      title: 'Cambio de Coche',
      description: 'Si quieres cambiar de vehículo, te compramos el tuyo aunque esté averiado o siniestrado. Facilitamos tu cambio de coche en Gavá con la mejor oferta.',
      features: ['Valoración justa', 'Proceso rápido', 'Sin complicaciones'],
    },
    {
      icon: 'ri-shield-check-fill',
      title: 'Compra con Garantía',
      description: 'Todos nuestros servicios incluyen garantía legal. Certificado de destrucción oficial y gestión completa de la baja en tráfico sin coste adicional.',
      features: ['Certificado oficial', 'Baja en tráfico', 'Todo incluido'],
    },
  ];

  return (
    <section ref={sectionRef} className="py-24 px-6 lg:px-12 bg-gradient-to-br from-gray-50 to-emerald-50">
      <div className="max-w-7xl mx-auto">
        <div 
          className={`text-center mb-16 transition-all duration-700 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          <span className="inline-block px-4 py-2 bg-emerald-100 text-emerald-700 rounded-full text-sm font-semibold mb-4">
            Servicios Adicionales
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Más Servicios de <strong>Compra de Coches en Gavá</strong>
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Además de coches siniestrados y averiados, también compramos <strong>vehículos accidentados, coches antiguos y ofrecemos servicio de cambio de coche en Gavá</strong> con las mejores condiciones del mercado
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {servicios.map((servicio, index) => (
            <div
              key={index}
              className={`bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all hover:-translate-y-2 cursor-pointer border border-gray-100 duration-700 ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'
              }`}
              style={{ transitionDelay: isVisible ? `${150 + index * 100}ms` : '0ms' }}
            >
              <div className="w-14 h-14 bg-gradient-to-br from-emerald-500 to-emerald-600 rounded-xl flex items-center justify-center mb-6">
                <i className={`${servicio.icon} text-white text-2xl`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                <strong>{servicio.title}</strong>
              </h3>
              <p className="text-gray-600 leading-relaxed mb-6 text-sm">
                {servicio.description}
              </p>
              <ul className="space-y-2">
                {servicio.features.map((feature, idx) => (
                  <li key={idx} className="flex items-center space-x-2 text-sm">
                    <i className="ri-check-line text-emerald-600 text-lg"></i>
                    <span className="text-gray-700">{feature}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div 
          className={`mt-16 bg-gradient-to-r from-emerald-600 to-emerald-700 rounded-2xl p-12 text-center shadow-xl transition-all duration-700 delay-500 ${
            isVisible ? 'opacity-100 scale-100' : 'opacity-0 scale-95'
          }`}
        >
          <h3 className="text-3xl font-bold text-white mb-4">
            ¿Tienes un Coche Accidentado en Gavá?
          </h3>
          <p className="text-white/90 text-lg mb-8 max-w-2xl mx-auto">
            Llámanos ahora y obtén una <strong>valoración gratuita en menos de 2 horas</strong>. Compramos tu coche accidentado al mejor precio del mercado con pago inmediato
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <a
              href="tel:932932913"
              className="inline-flex items-center space-x-2 bg-white text-emerald-600 px-8 py-4 rounded-lg font-bold text-lg hover:bg-gray-50 transition-all hover:scale-105 shadow-lg whitespace-nowrap"
            >
              <i className="ri-phone-fill"></i>
              <span>932 932 913</span>
            </a>
            <a
              href="https://wa.me/34932932913"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center space-x-2 bg-emerald-800 text-white px-8 py-4 rounded-lg font-bold text-lg hover:bg-emerald-900 transition-all hover:scale-105 shadow-lg whitespace-nowrap"
            >
              <i className="ri-whatsapp-fill"></i>
              <span>WhatsApp Directo</span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServiciosAdicionales;
